import { useEffectOnce } from 'react-use';

type MatomoAnalyticsProps = Readonly<{
   scriptLink: string;
   sideId: string;
}>;

export const MatomoAnalytics = (props: MatomoAnalyticsProps): null => {
   const { scriptLink, sideId } = props;

   useEffectOnce(() => {
      const scriptElement = document.createElement('script');
      scriptElement.type = 'text/javascript';
      scriptElement.innerHTML = `
<!-- Matomo -->
var _paq = window._paq = window._paq || [];
/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
_paq.push(['trackPageView']);
_paq.push(['enableLinkTracking']);
(function() {
  var u="${scriptLink}";
  _paq.push(['setTrackerUrl', u+'matomo.php']);
  _paq.push(['setSiteId', '${sideId}']);
  var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
  g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
})();
<!-- End Matomo Code -->
      `;

      document.head.appendChild(scriptElement);

      return () => {
         document.head.removeChild(scriptElement);
      };
   });

   return null;
};
